import { Observable, of, switchMap } from 'rxjs';

import { AuthService } from '@app/modules';
import { Injectable } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot } from '@angular/router';

import { ClientInfoDto } from '@sociuu/interfaces';

@Injectable({
  providedIn: 'root'
})
export class FeatureGuard implements CanActivate {
  constructor(
    private router: Router,
    private authService: AuthService
  ) {}
  
  public canActivate(route: ActivatedRouteSnapshot): Observable<boolean> {
    if (!route.data.feature) return this.checkFailed();
    return this.authService.clientInfo.pipe(
      switchMap((response: ClientInfoDto): Observable<boolean> => {
        const features: string[] = response.features;
        if (features.includes(route.data.feature)) return of(true);
        else return this.checkFailed();
      })
    );
  }

  private checkFailed(): Observable<boolean> {
    this.router.navigate(['/dashboard']);
    return of(false)
  }
}
